interface EnvConfig {
  apiUrl: string;
  env: string;
}

const getApiUrl = () => {
  const env = import.meta.env.VITE_ENV || 'development';

  // 开发环境：使用相对路径，通过 Vite 代理转发
  if (env === 'development') {
    return '';
  }

  // 测试环境：强制使用测试 API
  if (env === 'test') {
    return 'https://vadiutor-api-test.watchfun.cn';
  }

  // 生产环境：根据当前访问域名判断使用哪个 API
  const hostname = window.location.hostname;
  if (hostname.endsWith('.com')) {
    return 'https://vadiutor.com';
  } else if (hostname.endsWith('.cn')) {
    return 'https://api.vadiutor.cn';
  }

  // 默认使用 .cn 域名
  return 'https://api.vadiutor.cn';
};

const env: EnvConfig = {
  apiUrl: getApiUrl(),
  env: import.meta.env.VITE_ENV || 'development',
};

export const isDevelopment = env.env === 'development';
export const isTest = env.env === 'test';
export const isProduction = env.env === 'production';

/**
 * 判断是否是国内环境
 * @returns {boolean} 国内环境返回 true，国外环境返回 false
 *
 * 判断逻辑：
 * - .com 域名 → 国外环境（false）
 * - 其他（.cn、localhost、127.0.0.1 等）→ 国内环境（true）
 */
export const isDomestic = (): boolean => {
  const hostname = window.location.hostname;
  // .com 域名是国外环境
  if (hostname.endsWith('.com')) {
    return false;
  }
  // 其他所有情况（.cn、localhost、开发环境）都视为国内环境
  return true;
};

export default env; 